import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import styled from 'styled-components';
import {BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import {Card} from 'components/Card';
import {Loader} from 'components/Loader';
import { BaseComponent } from 'components/BaseComponent';

import "./style.scss";
import { selectWork } from '../../Api/selectors';
import { STATS_DOMAIN } from '../constants';
import { selectStats } from '../selectors';
import {formatCurrency, randomInt} from "../../../utils/number";
import Gauge from 'react-svg-gauge';
import * as _ from "lodash";
import {
  PieChart, Pie, Sector, Cell as PieCell, ResponsiveContainer
} from 'recharts';
import { List, Row, Cell } from '../../../components/List';


const STATE =  {
  add: false,
  property_name : 'name',
  property_value : ''
};

function getHexColor(value) {
  let string = value.toString(16);
  return (string.length === 1) ? '0' + string : string;
}

function gaugeColor(pct){
  let r = Math.floor(pct * 2.55);
  let g = Math.floor(255 - (pct * 2.55));
  let b = 0;
  return '#' + getHexColor(r) + getHexColor(g) + getHexColor(b);
}

function randomColors(num){
  return _.times(num, n => {
    return "#" + _.times(3, n => getHexColor(randomInt(10,150))).join("")
  }); 
}

/* eslint-disable react/prefer-stateless-function */
class StatsResultComp extends BaseComponent {

  constructor(props) {
    super(props, { ...STATE });
  }

  render(){

    return '';

  }

  
}

StatsResultComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  tag_id : PropTypes.number.isRequired,
  work : selectWork(STATS_DOMAIN)
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  stats : selectStats(ownProps.tag_id)
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch
  }
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const StatsResult = compose(
  withRouter,
  withConnect
)(StatsResultComp);
